/**
 * This method refines - sorts / slices and refines the requested cloud items
 * @param {*} originalCloud The cloud containing all words
 * @param {*} wordCount  The number of words
 * @param {number} maxTiers  Number of tiers of words
 */
function cloudRefiner(originalCloud, wordCount, maxTiers = 4) {
	let cloud = JSON.parse(JSON.stringify(originalCloud));  // prepare a cloud copy for processing
	wordCount = Math.floor(wordCount);                      // floor wordCount to nearest integer

 // sort by importance
 cloud = cloud.sort((a,b) => {
   if (a.importance < b.importance)  return 1;
   if (a.importance > b.importance)  return -1;
   return 0;
 });
 // slice list to  required size
 cloud = cloud.slice(0, wordCount);

 // set tier
 cloud.forEach((el, idx) => {
     el.tier = Math.floor((idx * maxTiers) / cloud.length) + 1;
 });

 // sort by elapsed time
 cloud = cloud.sort((a,b) => {
   if (a.time > b.time)  return 1;
   if (a.time < b.time)  return -1;
   return 0;
 });

 return cloud
}


/**
 * This method calls appropriate partitioners and refiners to get the list of clouds
 * @param {*} wordCount Number of items in each cloud
 * @param {*} cloudInfo Cloud Information
 */
function generateClouds(wordCount, cloudInfo) {
  let clouds = [];
  cloudInfo.forEach((cloud, index) => {
    clouds[index] = cloud.elements
  });
  return clouds
}

export {generateClouds, cloudRefiner}
